/** Названия полей для react-hook-forms */
export const FieldName = /*#__PURE__*/ {
  /** Контакты */
  Contacts: 'contacts',
  /** Точки "Откуда"/"Куда" */
  Route: 'route',
} as const
export type FieldName = typeof FieldName[keyof typeof FieldName]
